import React from 'react';
import { Chip } from '@mui/material';

interface StatusProps {
    description?: string;
    onClick?: (...args: any[]) => void;
    color?: string;
    [key: string]: any;
}

const Status = (props: StatusProps) => {
    let color = '#FFA500';
    if(props.description === 'Complete' || props.description === 'PII Removed'){
        color = '#448044';
    }else if(props.description === 'Cancelled'){
        color = '#AAA';
    }else if(props.description === 'Submitted'){
        color = '#8D8DFF';
    }else if(props.description === 'Failed'){
        color = '#EE3224';
    }else if(props.description === 'Ignored'){
        color = '#555';
    }else if(props.description === 'Duplicate'){
        color = '#4B9EC9';
    }else if(props.description === 'New'){
        color = '#275E7A';
    }else if(props.description === 'Draft'){
        color = 'rgb(75, 158, 201)';
    }
    return <Chip onClick={props.onClick} label={props.description} style={{backgroundColor: props.color || color, color: 'white', fontWeight: 'bold', minWidth: '7em', width: 'auto' }}/>;
};

export default Status;
